import { DefaultContext, useQuery } from '@apollo/client'
import React, { useContext, useMemo } from 'react'

import { RewardsDocument } from '../../../../../../graphql/search'
import useLogAndCaptureError from '../../../../../../hooks/useLogAndCaptureError'
import { ApolloClientsContext } from '../../../../../../lib/graphql/apollo'
import { useCustomerVipDiscount } from '../../../../../../lib/m2/hooks/useCustomerVipDiscount'
import { monthName, parseRewardsPeriod } from '../../../../../../lib/rewards/periods'
import * as Styled from './styled'

import greenInformationCircle from '../../../../../../img/green-information-circle.svg'

const VipDiscountsSection: React.FC = () => {
  const { isEligibleForVipDiscount, vipDiscountPercent } = useCustomerVipDiscount()

  const { comma: commaClient } = useContext(ApolloClientsContext)
  const {
    data: rewardsData,
    error: rewardsError,
    loading: rewardsLoading,
  } = useQuery(RewardsDocument, {
    client: commaClient,
    context: { useLatestTokenIfLoggedIn: true } as DefaultContext,
  })
  useLogAndCaptureError(rewardsError)

  const month = useMemo(() => {
    const rewardsSnapshots = rewardsData?.customer?.rewardsSnapshots?.nodes ?? []
    const [, previousSnapshot] = rewardsSnapshots
    const period = previousSnapshot?.period ? parseRewardsPeriod(previousSnapshot.period) : null
    return period ? monthName(period.month) : null
  }, [rewardsData?.customer?.rewardsSnapshots?.nodes])

  return (
    <div>
      <h3 className="small-h3">VIP discounts</h3>
      {isEligibleForVipDiscount ? (
        <>
          <Styled.Description>
            Buy more today, qualify for higher VIP discount level next month.
          </Styled.Description>
          {vipDiscountPercent && (
            <Styled.Container>
              <Styled.LeftHalf>
                <Styled.VipDiscountRibbon />
              </Styled.LeftHalf>
              <Styled.RightHalf>
                <Styled.VipDiscountPercentage>{vipDiscountPercent}</Styled.VipDiscountPercentage>
                <Styled.VipDiscountText>VIP Discount</Styled.VipDiscountText>
                {!rewardsLoading && (
                  <Styled.SmallDescription>
                    Based on {month ?? "last month's"} sales
                  </Styled.SmallDescription>
                )}
              </Styled.RightHalf>
            </Styled.Container>
          )}
        </>
      ) : (
        <>
          <Styled.AlertContainer>
            <Styled.AlertIconWrapper>
              <Styled.AlertIcon src={greenInformationCircle} />
            </Styled.AlertIconWrapper>
            <Styled.AlertContent>
              {`Currently unavailable for your account. `}
              <Styled.Email
                href={'mailto:salesoperations@designsforhealth.com'}
                target="_blank"
                rel="noreferrer"
              >
                Contact us
              </Styled.Email>
              {` if you think this is a mistake.`}
            </Styled.AlertContent>
          </Styled.AlertContainer>
        </>
      )}
    </div>
  )
}

export default VipDiscountsSection
